// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box {
  width: 31%;
  height: 6.5rem;
  border-radius: 15px;
  margin: 2px;
  background-color: white;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  padding: 15px;
}

.data {
  height: 50%;
  margin-bottom: 0px;
}

.iconPart {
  height: 50%;
}

.icon {
  width: 1.7rem;
  height: 1.7rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
}

.data {
  display: flex;
  flex-direction: column;
  color: black;
}

p {
  text-wrap: nowrap;
  font-size: 12px;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/Coach/widgets/some-infos/some-infos.component.scss"],"names":[],"mappings":"AAEA;EACI,UAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iDAAA;EACA,aAAA;AADJ;;AAME;EACE,WAAA;EACA,kBAAA;AAHJ;;AAME;EACE,WAAA;AAHJ;;AAME;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAHJ;;AAOE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAJJ;;AAQA;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;AALJ","sourcesContent":["//CARD \r\n\r\n.box {\r\n    width: 31%;\r\n    height: 6.5rem;\r\n    border-radius: 15px;\r\n    margin: 2px;\r\n    background-color: white;\r\n    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;\r\n    padding: 15px;\r\n  }\r\n  \r\n \r\n  \r\n  .data {\r\n    height: 50%;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .iconPart{\r\n    height: 50%;\r\n  }\r\n\r\n  .icon{\r\n    width: 1.7rem;\r\n    height: 1.7rem;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    color: white;\r\n  }\r\n  \r\n  \r\n  .data {\r\n    display: flex;\r\n    flex-direction: column;\r\n    color: black;\r\n  }\r\n  \r\n  \r\np{\r\n    text-wrap:nowrap;\r\n    font-size: 12px;\r\n    margin-bottom: 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
